(function () {
  'use strict';
  /* The deadline is fixed to New York time so every shopper sees the same
     instant even when their own device is in another time zone. */
  var orderEnd = Date.parse('2026-09-24T10:00:00-04:00');
  var banner = document.querySelector('[data-mega-sale]');
  var orderCountdown = document.querySelector('[data-order-countdown]');
  var timer = null;

  function two(value) { return String(value).padStart(2, '0'); }
  function remaining(deadline) {
    var seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;
    return (days ? days + 'd ' : '') + two(hours) + 'h ' +
      two(minutes) + 'm ' + two(remainingSeconds) + 's';
  }

  function update() {
    var now = Date.now();
    var orderActive = now < orderEnd;
    if (banner) banner.hidden = !orderActive;
    if (orderCountdown && orderActive) orderCountdown.textContent = 'Order deadline in ' + remaining(orderEnd);
    if (!orderActive) {
      if (timer) window.clearInterval(timer);
    }
  }

  update();
  if (Date.now() < orderEnd) timer = window.setInterval(update, 1000);
})();
